// Keeping this for future troubleshooting.
const brightcoveConfig = {
  liveStream: {
    accountId: '710857117001',
    testVideoId: '6298856962001',
  },
  master: {
    accountId: '1241706627001',
    testVideoId: '6298850459001',
  },
}

const translateVideoConfig = {
  youtube: { providerType: 'youtube', videoId: 'CadZpJ7AlvQ' },
  brightcove: { providerType: 'youtube', videoId: 'PexANw32ywM' },
}

const SUPPRESSED_PLAYER_ERRORS = ['The node before which the new node is to be inserted is not a child of this node']

export { brightcoveConfig, translateVideoConfig, SUPPRESSED_PLAYER_ERRORS }
